module.exports = __webpack_public_path__ + "d36dcda4f9e0afbff0a525ee3ea0f891.png";